<template>
  <div class="box box-primary">
    <div class="box-header with-border">
      <div
        style="text-align:center; font-size: 20px;text-align:left;color:#5b6c7f;margin-bottom:20px;"
      >
        {{ $route.params.id ? $t('newsManagement.residentNews.update') : $t('newsManagement.residentNews.add') }}
      </div>
    </div>
    <form class="form-horizontal">
      <div class="box-body">
        <div class="form-group">
            <label class="col-sm-3 control-label">{{
                $t("banner.image")
            }}</label>
            <div class="col-sm-6">
              <img
                id="news-img-id"
                :src="imgUrl !== null && imgUrl !== '' ? imgUrl : noImgDefault"
                class="news-img-class img-responsive"
                alt="news-img">
              <div style="padding-top: 6px; text-align: center">
                <input
                  id="upload-news-img"
                  type="file"
                  accept="image/*"
                  @change="onSelectResidentImg">
                <p>{{ $t('banner.clickImageToAddOrUpdate') }}</p>
                <span
                  v-if="imgUrl !== null && imgUrl !== ''"
                  class="remove-news-img"
                  @click="onClickRemoveResidentImg">{{ $t('common.delete') }}</span>
              </div>
            </div>
        </div>
        <div class="form-group required">
          <label class="col-sm-3 control-label">{{
            $t('banner.title')
          }}</label>
          <div class="col-sm-6">
            <input
              v-model="title"
              type="text"
              class="form-control"
              :placeholder="$t('banner.title')"
            />
          </div>
        </div>
        <div class="form-group required">
          <label class="col-sm-3 control-label">{{
            $t('newsManagement.residentNews.content')
          }}</label>
          <div class="col-sm-6">
            <textarea
              v-model="content"
              type="text"
              class="form-control"
              rows="6"
              :placeholder="$t('newsManagement.residentNews.content')"
            />
          </div>
        </div>
        <div class="form-group required">
            <label class="col-sm-3 control-label">{{
                $t('newsManagement.residentNews.attachmentsFile')
            }}</label>
            <div class="col-sm-6">
                <!-- Upload new document file -->
                <div style="position: relative;">
                <label for="file-upload" class="custom-file-upload">
                    <i
                    class="glyphicon glyphicon-file"
                    style="position: absolute; left: 10px; top: 30%; color: #cccccc; font-size: small;"
                    ></i>
                    <span style="font-size: small; word-wrap: break-word;">{{
                    documentFileName ? documentFileName : $t('newsManagement.residentNews.fileUpload')
                    }}</span>
                </label>
                <input v-on:change="onFileChange" id="file-upload" type="file" />
                </div>
            </div>
        </div>
      </div>
      <div class="box-footer">
        <button
          type="button"
          class="btn btn-labeled btn-danger"
          style="margin-right: 5px; background-color: #f29911;border-color: #f29911;"
          @click="onBack"
        >
          <span class="btn-label"> <i class="fa fa-mail-reply"></i> </span>
          {{ $t("common.back") }}
        </button>

        <button
          type="button"
          class="btn btn-labeled btn-success pull-right"
          style="margin-right: 5px;"
          @click="onCreateBanner"
        >
          <span class="btn-label">
            <i class="glyphicon glyphicon-ok"></i>
          </span>
          {{ $t("common.save") }}
        </button>
      </div>
    </form>
    <lte-core-alert
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"
    ></lte-core-alert>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#1E90FF"
    ></loading>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import configuration from "../../lib/config";
// import utils from '@/lib/utils';
import axios from "axios";

export default {
  name: "ResidentsAdd",
  data() {
    return {
      noImgDefault: configuration.imgUrlConfig.img_other_no_picture_available,
      isLoading: false,
      token: null,
      media_dns: null,
      documentFileName: null,
      documentFileSize: null,
      documentFile: null,
      imgUrl: null,
      title: null,
      documentUrl: null,
      content: null
    };
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR"
    ])
  },
  watch: {
  },
  created () {
      this.GET_TOKEN_UPLOAD()
      .then(
        function(res) {
          this.token = res.token;
          this.media_dns = res.domain;
        }.bind(this)
      )
      .catch(
        function() {
          this.ERROR_TOAST();
        }.bind(this)
      );
    let residentNewsId = this.$route.params.id
    if (residentNewsId) {
      this.GET_RESIDENT_NEWS_DETAIL({id: residentNewsId}).then(
        function (res) {
          let data = res
          this.title = data.title
          this.content = data.content
          this.documentUrl = data.document_url
          this.documentFileName = data.document_name
          this.imgUrl = data.img_url
        }.bind(this)
      )
    }
  },
  mounted() {
    $(function () {
      $('#news-img-id').on('click', function () {
        $('#upload-news-img').click()
      })
    })
  },
  methods: {
    /**
     * On image change
     */
    onFileChange: function(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.documentFileName = files[0].name;
      this.documentFileSize = files[0].size;
      this.getResultFile(files[0]);
    },
    /**
     * Get result file
     */
    getResultFile: function(file) {
      let vm = this;
      vm.documentFile = file;
    },
    /**
     * Set default
     */
    setDefault: function () {
        this.banner.title = null
        this.banner.imageUrl = null
        this.banner.imageFile = null
        this.positionSelected = null
    },
    /**
     * Create banner
     */
    onCreateBanner: async function () {
        let filter = {
          title: this.title,
          documentUrl: this.documentUrl,
          content: this.content,
          documentName: this.documentFileName,
          imgUrl: this.imgUrl
        }
        if (this.documentFile) {
          await this.uploadBannerImage()
          filter['documentUrl'] = this.documentUrl
        }
        let residentNewsId = this.$route.params.id
        if (residentNewsId) {
          this.UPDATE_RESIDENT_NEWS({id: residentNewsId, ...filter}).then(
            function () {
              this.SUCCESS_TOAST()
            }.bind(this)
          ).catch(
            function () {
              this.ERROR_TOAST()
            }.bind(this)
          )
        } else {
          this.CREATE_RESIDENT_NEWS(filter).then(
            function () {
              this.onClickRemoveDocumentFile()
              this.title = null
              this.content = null
              this.documentFileName = null
              this.SUCCESS_TOAST()
            }.bind(this)
          ).catch(
            function () {
              this.ERROR_TOAST()
            }.bind(this)
          )
        }
    },
    /**
     * Upload advertisement image
     */
    uploadBannerImage: async function () {
      let formData = new FormData()
      formData.append('file', this.documentFile)
      formData.append('directory', 'apartment/news_residents/file/')
      formData.append('forceOverride', true)
      await axios({
        method: 'POST',
        timeout: 6000,
        url: this.media_dns + '/api/v1/upload/',
        data: formData,
        headers: { Authorization: `JWT ${this.token}` }
      }).then(
        async function (res) {
          let data = res.data
          this.documentUrl = data.domain + data.url
        }.bind(this)
      ).catch(
        async function () {
          this.documentUrl = null
        }.bind(this)
      )
    },
    /**
     * Back
     */
    onBack: function () {
        window.history.back()
    },
    /**
     * Remove issuance img
     */
    onClickRemoveDocumentFile: function () {
      let inputForm = $('#file-upload')
      inputForm.val('')
      this.documentFile = null
      this.documentUrl = null
    },
    // /**
    //  * Select issuance img
    //  */
    // onSelectBannerImg: function (e) {
    //   let files = e.target.files || e.dataTransfer.files
    //   if (!files.length) return
    //   this.getResultFile(files[0])
    //   this.banner.imageUrl = URL.createObjectURL(files[0])
    // },
    /**
     * Select issuance img
     */
    onSelectResidentImg: async function (e) {
      let files = e.target.files || e.dataTransfer.files
      if (!files.length) return
      await this.getImgFile(files[0])
      this.imgUrl = URL.createObjectURL(files[0])
      await this.uploadImgfile()
    },
    getImgFile: function(file) {
      let vm = this;
      vm.imgFile = file;
    },
    uploadImgfile: async function () {
      let formData = new FormData()
      formData.append('file', this.imgFile)
      formData.append('directory', 'apartment/news_residents/img/')
      formData.append('forceOverride', true)
      await axios({
        method: 'POST',
        timeout: 6000,
        url: this.media_dns + '/api/v1/upload/',
        data: formData,
        headers: { Authorization: `JWT ${this.token}` }
      }).then(
        async function (res) {
          let data = res.data
          this.imgUrl = data.domain + data.url
        }.bind(this)
      ).catch(
        async function () {
          this.imgUrl = null
        }.bind(this)
      )
    },
    /**
     * Remove issuance img
     */
    onClickRemoveResidentImg: function () {
      let inputForm = $('#upload-news-img')
      inputForm.val('')
      this.imgUrl = null
      // this. = null
    },
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "ON_SHOW_TOAST",
      "GET_TOKEN_UPLOAD",
      "CREATE_RESIDENT_NEWS",
      "GET_RESIDENT_NEWS_DETAIL",
      "UPDATE_RESIDENT_NEWS"
    ]),
  },
  components: {
    Loading,
    "lte-core-alert": LTECoreAlert
  }
};
</script>
<style scoped>
.form-group.required .control-label:after {
  color: #d00;
  position: absolute;
  margin-left: 8px;
  margin-top: -3px;
  font-family: "FontAwesome";
  font-weight: normal;
  font-size: 9px;
  content: "\f069";
}
.banner-img-class{
  width: 80%;
  cursor: pointer;
}
input[type="file"] {
  display: none;
}
.remove-banner-img{
  color: #EF5350;
  cursor: pointer;
}
.remove-banner-img:hover{
  text-decoration: underline;
}
.custom-file-upload {
  border: 1px solid #ccc;
  display: inline-block;
  padding: 6px 25px;
  width: 100%;
  border-radius: 5px;
  cursor: pointer;
}
.news-img-class{
  width: 100%;
  cursor: pointer;
  margin: auto;
  max-width: 250px;
  max-height: 300px;
}
.remove-news-img{
  color: #EF5350;
  cursor: pointer;
}
.remove-news-img:hover{
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/views/News/ResidentsAdd.vue